import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from '../../../../environments/environment';

export const httpClientInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  let isApiKeyRequest = true;
    const currentUser = authService.currentUserValue;

  if (request.url.startsWith(environment.apiUrl)) {
    const isAuthenticated = currentUser !== null;
    const apiKey = authService.getParamValueQueryString('api_key');
    if (apiKey) {
      request = request.clone({ setHeaders: { ApiKey: apiKey } });
    } else if (isAuthenticated) {
      isApiKeyRequest = false;
      request = request.clone({
        setHeaders: {
          Authorization: `${currentUser.accessToken}`,
          IdToken: `${currentUser.idToken}`,
        },
      });
    }
  }
  return next(request).pipe(
    catchError(error => {
      if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 0)) {
        if (!isApiKeyRequest) {
          return authService.refreshToken().pipe(
            switchMap((tokenData: any) => {
              const newAuthToken = tokenData.accessToken;
              const modifiedReq = request.clone({
                headers: request.headers.set('Authorization', `${newAuthToken}`),
              });
              return next(modifiedReq);
            }),
            catchError(refreshError => {
              router.navigate(['/login']);
              return throwError(() => refreshError);
            }),
          );
        }
        authService.removeUserData();
        router.navigate(['/login']);
        return throwError(() => 'Client Not Authenticated!');
      } else {
        throw error;
      }
    }),
  );
};
